export const copyImpactCounter = [
  {
    title: 'Cut test time up to',
    subCopy: 'Read the Netflix story',
    subCopyUrl: '/customers/story/netflix/',
    className: 'test-time',
  },
  {
    title: 'Decreased build time by',
    subCopy: 'Read the Revolut story',
    subCopyUrl: '/customers/story/revolut/',
    className: 'build-time',
  },
];
